import { gql } from '@apollo/client';
import { PACK_BASE_FRAGMENT } from 'apollo/pack/pack.fragment';

export const SAMPLE_KEY_FRAGMENT = gql`
    fragment SampleKeyFragment on SampleKey {
        code
        root
        quality
    }
`;

export const CLASSIFIER_FRAGMENT = gql`
    fragment ClassifierFragment on Classifier {
        id
        code
        type
        isPackClassifier
    }
`;

export const SAMPLE_FRAGMENT = gql`
    fragment SampleFragment on Sample {
        guid
        name
        bpm
        credits
        duration
        isDownloaded
        isFavorited
        isRecommendationFiller
        sampleState
        sampleType
        waveformUrl
        key {
            ...SampleKeyFragment
        }
        pack {
            ...PackBaseFragment
        }
        classifiers {
            ...ClassifierFragment
        }
    }
    ${SAMPLE_KEY_FRAGMENT}
    ${PACK_BASE_FRAGMENT}
    ${CLASSIFIER_FRAGMENT}
`;
